<template>
  <v-textarea
    v-bind="computedProps"
    v-on="$listeners"
    outlined
    clearable
  ></v-textarea>
</template>

<script>
import { VTextarea } from "vuetify/lib";
export default {
  name: "STextArea",
  extends: VTextarea,
  props: {
    label: {
      type: String,
      default: "label",
    },
    icon: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "primaryColor",
    },
  },
  computed: {
    computedProps() {
      return {
        ...this.$props,
        label: this.label,
        prependIcon: this.icon,
        color: this.color,
      };
    },
  },
};
</script>

<style></style>
